function convertSwatchTitlesToSentenceCase () {
    let swatches = document.querySelectorAll(".colour-swatch-title");
    if (swatches.length === 0) return;

    swatches.forEach(swatch => {
        let currentTitle = swatch.getAttribute("title") || swatch.textContent;
        let convertedText = toSentenceCase(currentTitle);
        swatch.setAttribute("title", convertedText);
        swatch.textContent = ("title", convertedText);
        swatch.classList.add("colour-swatch-title-formatted");
    });
}

function toSentenceCase (text) {
    if (!text) return text;

    return text
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
        .trim();
}


function openDropdown () {
    const dropdownContainer = document.querySelector('.dropdown-content');
    const smallDropdownContainer = document.querySelector('.small-dropdown-content');
    const svg = document.querySelector('.dropdown-icon');

    // Function to toggle visibility
    const toggleDropdown = (dropdown) => {
        if (dropdown.classList.contains('show')) {
            dropdown.classList.remove('show');
            svg.style.transform = "rotate(0deg)";
        } else {
            dropdown.classList.add('show');
            svg.style.transform = "rotate(180deg)";
        }
    };

    if (dropdownContainer)
        toggleDropdown(dropdownContainer);
    else if (smallDropdownContainer)
        toggleDropdown(smallDropdownContainer);
}

function closeDropdownOnClickOutside () {
    document.addEventListener("click", (event) => {
        const swatchContainer = document.querySelector(".colour-swatch-container");
        const dropdownContainer = document.querySelector('.dropdown-content');
        const smallDropdownContainer = document.querySelector('.small-dropdown-content');
        const dropdownIcon = document.querySelector('.dropdown-icon');

        const isClickInsideDropdown = swatchContainer?.contains(event.target) 
            || event.target == swatchContainer;

        // If the click is outside, close the dropdown
        if (!isClickInsideDropdown) {
            if (dropdownContainer?.classList.contains("show"))
                dropdownContainer.classList.remove("show");
            
            if (smallDropdownContainer?.classList.contains("show"))
                smallDropdownContainer.classList.remove("show");
            
            if (dropdownIcon)
                dropdownIcon.style.transform = "rotate(0deg)";
        }
    });
}

function dropdownHeightCalculator () {
    let colourDropdowns = document.querySelectorAll('.small-dropdown-content');

    colourDropdowns.forEach(dropdown => {
        let computedStyle = window.getComputedStyle(dropdown);
        let paddingTop = parseFloat(computedStyle.paddingTop);
        let paddingBottom = parseFloat(computedStyle.paddingBottom);
        let totalVerticalPadding = paddingTop + paddingBottom;

        let colourElements = dropdown.querySelectorAll('.colour-swatch-link');

        // Temporarily show the dropdown to measure its content
        let originalDisplay = dropdown.style.display; // Store original display style
        dropdown.style.display = 'block'; // Temporarily show the dropdown

        let totalHeight = 0;

        // Calculate the total height of all colour elements, plus extra to account for padding
        colourElements.forEach(element => {
            totalHeight += element.clientHeight;
        });

        totalHeight += totalVerticalPadding; // Add the parent dropdown's vertical padding

        dropdown.style.height = `${totalHeight}px`;

        // Restore the original display style
        dropdown.style.display = originalDisplay;
    });
}

closeDropdownOnClickOutside();
dropdownHeightCalculator();

document.addEventListener("DOMContentLoaded", convertSwatchTitlesToSentenceCase, false);